angular.module('zc.projects')

.controller 'CampaignCtrl', (
    $scope,
    $state,
    $translate,
    Devise,
    Page,
    PageType,
    Project,
    Campaign,
    SearchFilter,
    Template,
    ClearanceItemSet,
    CampaignSegment,
    SegmentMatcher,
    MongoSession,
    MongoConversion,
    MongoHistory,
    campaign,
    currentProject,
    campaignEventOrder,
    campaignEventNotices,
    githubUrl,
    InterestWidget,
    interestWidgets) ->

  DATE_UNTIL = moment().subtract(1, 'hours').toDate()

  $scope.sampleSessionSize = 500
  $scope.historySize = 5
  $scope.historyTime = 30
  $scope.sessions = []
  $scope.lpUrls = []

  $scope.isAb = campaign.campaign_control_percent isnt 0 and not campaign.is_secret_ab

  Page.setBodyClass ''
  $translate('projectsCampaigns.showController.campaignDetail').then (translation) ->
    Page.setTitle translation

  $scope.Project = Project
  $scope.currentProject = currentProject

  findInterestWidget = (campaign) ->
    _.find(interestWidgets, (iw) -> (iw.campaign.id is campaign.id))

  iw = findInterestWidget campaign
  if iw
    campaign.iw_current_status = iw.status

  $scope.campaign = campaign
  $scope.isV1 = campaign.api_version == 1
  $scope.Campaign = Campaign
  $scope.Devise = Devise

  $scope.filters = SearchFilter.resolveFromLocation()
  $scope.previewUrl = Campaign.previewUrl(currentProject.base_url, campaign)
  $scope.adminUrl = Campaign.adminUrl(currentProject.id, campaign)

  Campaign.all(projectId: currentProject.id).then (allCampaigns) ->
    $scope.otherCampaigns = []
    for c in allCampaigns
      continue if c.campaign_device not in [$scope.campaign.campaign_device, 'devicefree']
      continue if c.current_status not in ['active', 'pending', 'blocked', 'preview']
      continue unless c.is_supported_by_widget
      c.previewUrl = "#{Campaign.previewUrl(currentProject.base_url, c)}&zc_widget_id=#{$scope.campaign.element.id}"
      $scope.otherCampaigns.push c

  $scope.campaignEventOrder = campaignEventOrder
  $scope.campaignEventNotices = campaignEventNotices
  $scope.githubUrl = githubUrl

  $scope.$on '$stateChangeSuccess', (ev, toState, toParams, fromState, fromParams) ->

    # When accessing campaign stats from reports page,
    # apply the viewed reports month to date filters and reset device and segment filters.
    if fromState?.name == 'admin.projects.reports.show'
      return unless _.get fromParams, 'reportId'

      $scope.filters = SearchFilter.getDefaultReportFilters(fromParams.reportId)
      $scope.updateFilters()

    if toState?.name == 'admin.projects.campaigns.show'
      $state.go 'admin.projects.campaigns.show.stats', toParams

  if $scope.campaign.clearance_item_set_id
    ClearanceItemSet.find({
      projectId: $scope.currentProject.id
      id: $scope.campaign.clearance_item_set_id
    }).then (res) ->
      $scope.clearanceItemSet = res

  $scope.active = if $scope.campaign.status is "activated" then true else false
  if $scope.campaign.end_at > new Date() and $scope.campaign.status != "terminated"
    $scope.current = true
  else
    $scope.current = false

  $scope.canDestroy = campaign.current_status in ['incomplete', 'preview']
  $scope.hasIw = !!iw

  $scope.updateIwStatus = (status) ->
    iw.status = status
    InterestWidget.update($scope.campaign.apikey, iw.id, iw)
    .then (res) ->
      $state.go 'admin.projects.campaigns.list',
        projectId: $state.params.projectId
      , reload: true

  Template.all($scope.currentProject.id)
  .then (templates) ->
    if $scope.campaign.template_type
      template = _.find templates,
        name: $scope.campaign.template_type
      if template
        $scope.campaign.template = template

  $scope.isActiveState = (state) ->
    $state.current.name == state

  $scope.terminate = ->
    $scope.current = false
    Campaign.terminate
      projectId: $state.params.projectId
      campaignId: $state.params.campaignId

  $scope.destroy = ->
    Campaign.destroy
      projectId: $state.params.projectId
      campaignId: $state.params.campaignId
    .then ->
      $state.go 'admin.projects.campaigns.list',
        projectId: $state.params.projectId
      , reload: true

  $scope.updateFilters = () ->
    $scope.updatedFilters =
      start_at: moment($scope.filters.start_at).startOf('day').valueOf()
      end_at: moment($scope.filters.end_at).add(1, 'day').valueOf()
    SearchFilter.set($scope.filters)
    $scope.$broadcast('filtersUpdated')

  $scope.resetFilters = ->
    $scope.$broadcast('filtersReset')

  $scope.destroy = ->
    Campaign.destroy
      projectId: $scope.campaign.project_id
      campaignId: $scope.campaign.id
    .then $scope.onUpdate

  $scope.goToShow = ->
    $state.go 'admin.projects.campaigns.show.stats',
      campaignId: $scope.campaign.id

  $scope.goToEdit = (step)->
    state = 'admin.projects.campaigns.edit'
    state += ".#{step}" if step
    $state.go state,
      campaignId: $scope.campaign.id

  $scope.hasOptionType = (option_category) ->
    return undefined unless $scope.campaign.template
    for element in $scope.campaign.template.template
      if element.option_category is option_category
        return true

  $scope.publish = (_usid) ->
    Campaign.publish
      apikey: $scope.campaign.apikey
      campaign_id: $scope.campaign.id
      _usid: _usid
    .then ->
      $scope._usid = null
      alertify.success "#{_usid} #{$translate.instant('projectsCampaigns.showController.campaignDetail')}"
    , (err) ->
      $scope._usid = null
      alertify.error err

  $scope.updateFilters()

  $scope.$watch 'filters', ->
    start_at = moment($scope.filters.start_at).format('YYYYMMDD')
    end_at = moment($scope.filters.end_at).format('YYYYMMDD')
    $scope.filename = "campaign_#{$scope.campaign.id}_#{start_at}_#{end_at}.csv"
  , true

  $scope.showInterestWidgetData = false
  Campaign.isWidget(campaign)
  .then (isWidget) ->
    $scope.showInterestWidgetData = isWidget

  findSessions = (query) ->
    return unless $scope.campaign.segment
    CampaignSegment.get($scope.campaign.project_id, $scope.campaign.segment_id).then (segment) ->
      $scope.generateLPLinks(segment)
      CampaignSegment.getMongoQuery(segment)
    .then (query) ->
      query = SegmentMatcher.createSegmentQuery(query)
      MongoSession.find _.assignIn(query,
        apikey: $scope.currentProject.apikey
        device: SegmentMatcher.getCombinedDeviceCondition($scope.campaign.campaign_device)
        opened_at:
          # FIXME: To avoid posting a heavy query.
          #        Alternative solution is required to ensure that this can get 'just right' amount of data.
          $gte: moment(DATE_UNTIL).subtract(1, 'day').toDate()
          $lt:  DATE_UNTIL
      )
      ,
        sort: '-opened_at'
        limit: $scope.sampleSessionSize
        fields: [
          'conversion_count'
          'predictions_min_before_cart.global_conversion_rate'
          'predictions_max_before_cart.global_conversion_rate'
          'average_recent5_item_price'
        ]
    .then (sessions) ->
      $scope.sessions = sessions

  $scope.$watch 'sampleSessionSize', findSessions

  $scope.toggleShowAB = ->
    $scope.isAb = !$scope.isAb
    $scope.$broadcast('isAbChanged', $scope.isAb)

  $scope.hideCodeIncentiveConfigItem = (item) ->
    return false unless /^timesale_ver5/.test($scope.campaign.template_type)
    incentive = $scope.campaign.incentives[0]
    return false unless incentive
    return false unless incentive.incentive_type in ['coupon_url', 'api_url']
    if item.name in ['code_name', 'code_copy', 'enable_coupon_clipboard', 'code_condition']
      return true
    if incentive.incentive_type is 'api_url' and item.name in ['linkage_url', 'remove_target_blank_present']
      return true
    return false

  $scope.hideTimerConfigItem = (item) ->
    if item.name is 'enables_banner_timer' and not $scope.campaign.element.message.enables_timer
      return true
    false

  unJankRegEx = (regex) ->
    # the page type settings page splits the path but you cant query just the path in mongodb so you gotta dejank the regex first
    re = regex
    if regex.charAt(0) == '^'
      re = regex.substr(1)
    re.replace('//', '/')

    re

  checkOfferExists = (offer) ->
    offer && offer != 'NOT_SELECTED'

  replacePrefix = (prefix) ->
    match_pattern = prefix.match_pattern
    match_pattern = match_pattern.replaceAll('/', '\\/')
    match_pattern = match_pattern.replaceAll('.', '\\.')
    match_pattern = match_pattern.replaceAll('?', '\\?')
    return match_pattern

  matchPageType = (pageTypes, offerName, offerType, matchQuery) ->
    matchQuery.url ||= {}
    matchedPages = _.filter(pageTypes, (pageType) -> [pageType.page_type, pageType.custom_name].includes(offerName))

    return if matchedPages.length == 0

    $scope.lpSegmentSet = true
    prefixes = _.filter(matchedPages, { match_type: 'prefix'})

    if offerType == 'limit'
      if prefixes
        matchQuery.url.$regex = _.map(prefixes, replacePrefix).join('|')
      else
        matchQuery.url.$regex = unJankRegEx(matchedPages[0].match_pattern)
    else
      # TODO in mongo 4 you can do {$not: {$regex: 'string regex'}}
      # but in mongo 3.x you can't
      # and you can't send regex objects in the get request to facade so this is just the way it is
      matchQuery.url.$not = unJankRegEx(matchedPages[0].match_pattern)

  $scope.generateLPLinks = (segment) ->
    startAt = moment().subtract($scope.historyTime, 'minutes').toDate()
    endAt = new Date()

    match = {
      apikey: $scope.currentProject.apikey,
      device: SegmentMatcher.getCombinedDeviceCondition($scope.campaign.campaign_device),
      opened_at: { $gte: startAt },
      closed_at: { $lt: endAt }
    }

    pipeline = [
      { $project: { url: '$url' } },
      { $sortByCount: '$url' },
    ]

    PageType.all($scope.currentProject.id).then((pageTypes) ->
      offerLimit = _.get(segment, ['conditions_json', 'limit_to_landing_page_types', '0'])
      if checkOfferExists offerLimit
        matchPageType pageTypes, offerLimit, 'limit', match

      offerExclude = _.get(segment, ['conditions_json', 'exclude_landing_page_types', '0'])
      if checkOfferExists offerExclude
        matchPageType pageTypes, offerExclude, 'exclude', match

      offerSession = _.get(segment, ['conditions_json', 'limit_to_sessions_who_visit', '0'])
      if checkOfferExists offerSession
        matchPageType pageTypes, offerSession, 'limit', match

      MongoHistory.aggregate(
        { apikey: $scope.currentProject.apikey },
        {
          match: match,
          pipeline: pipeline
          limit: $scope.historySize
        }
      )
    ).then((urls) ->
        if urls != undefined
          $scope.lpUrls = _.map urls, (url) -> Campaign.previewUrl(url._id, $scope.campaign)
    )



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects.campaigns/show.controller.js.coffee